import React, { Component } from 'react'
import IconMenu from 'material-ui/IconMenu'
import IconButton from 'material-ui/IconButton'
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert'
import Send from 'material-ui/svg-icons/content/send'
import Clear from 'material-ui/svg-icons/content/clear'
import MailIcon from 'material-ui/svg-icons/content/mail'
import InfoIcon from 'material-ui/svg-icons/action/info'
import Delete from 'material-ui/svg-icons/action/delete'
import CheckCircle from 'material-ui/svg-icons/action/check-circle'
import Contacts from 'material-ui/svg-icons/communication/contacts'
import Cancel from 'material-ui/svg-icons/navigation/cancel'
import PersonAdd from 'material-ui/svg-icons/social/person-add'
import FlatButton from 'material-ui/FlatButton'
import Dialog from 'material-ui/Dialog'
import Snackbar from 'material-ui/Snackbar'
import Divider from 'material-ui/Divider'
import { FormattedMessage } from 'react-intl'
import { ListItem } from 'material-ui/List'
import ReactTooltip from 'react-tooltip'

import Modal from './Modals'
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui/Table'

import images from '../../../config/images'
import { AddText, ALertHeaderText, AlertText, InviteText } from './styles'
import { checkJapanese, getToken } from '../../../lib'

export default class Invite extends Component {
  state = {
    rows: [1, 2, 3, 4, 5],
    selectedRows: [],
    open: false,
    user: null,
    snackbarOpen: false,
    snackbarMessage: '',
    listModalOpen: false,
    listModalPurpose: null,
    isEmpty: false,
    singleIconClick: false
  }

  handleSendTouch = (e, message, purpose, participantId) => {
    const token = getToken()
    const conferenceId = this.props.selectConferenceId

    this.setState({
      singleIconClick: true,
      snackbarOpen: true,
      snackbarMessage: message
    })

    if (purpose === 'send') {
      e.target.style.fill =
        e.target.style.fill === 'green' ? '#afb8c5' : 'green'
      this.props.inviteParticipant(token, participantId, conferenceId)
    } else {
      e.target.style.fill = e.target.style.fill === 'red' ? '#afb8c5' : 'red'
      this.props.deleteParticipant(token, participantId, conferenceId)
    }
  }

  actionForAll = (purpose, message) => {
    const token = getToken()
    const conferenceId = this.props.selectConferenceId
    this.setState({
      singleIconClick: true,
      selectedRows: [],
      snackbarOpen: true,
      snackbarMessage: message
    })
    this.props.participants.map((val, index) => {
      if (purpose === 'invite') {
        this.props.inviteParticipant(token, val.id, conferenceId)
      } else if (purpose === 'delete') {
        this.props.deleteParticipant(token, val.id, conferenceId)
      }
    })
  }

  handleSendToMultiple = (e, message) => {
    const {selectedRows} = this.state
    const token = getToken()
    const conferenceId = this.props.selectConferenceId
    this.setState({
      singleIconClick: true,
      selectedRows: [],
      snackbarOpen: true,
      snackbarMessage: message
    })
    this.props.participants.map((val, index) => {
      if (selectedRows.indexOf(index) !== -1) {
        this.props.inviteParticipant(token, val.id, conferenceId)
      }
    })
  }

  handleDeleteTouch = (e, user) => {
    const {selectedRows} = this.state
    const token = getToken()
    const conferenceId = this.props.selectConferenceId
    this.setState({
      singleIconClick: true,
      selectedRows: [],
      snackbarOpen: true,
      snackbarMessage: (
        <div>
          {user}
          <FormattedMessage id="seminarActions.singleRemoved"/>
        </div>
      )
    })
    this.props.participants.map((val, index) => {
      if (selectedRows.indexOf(index) !== -1) {
        this.props.deleteParticipant(token, val.id, conferenceId)
      }
    })
  }

  handleTouchTap = () => {
    this.setState({
      snackbarOpen: true,
      open: false,
      snackbarMessage: (
        <div>
          {this.state.user}
          <FormattedMessage id="seminarActions.removedMessage"/>
        </div>
      )
    })
  }

  handleClose = () => this.setState({open: false})
  handleRequestClose = () => this.setState({snackbarOpen: false})
  handleListModalClose = () => this.setState({listModalOpen: false})
  hadleListClick = (e, purpose) => {
    const token = getToken()
    this.setState({listModalOpen: true, listModalPurpose: purpose})
    if (purpose === 'import') {
      this.props.fetchContactList(token)
    }
  }

  getSnackbarDetails = message => {
    this.setState({
      snackbarOpen: true,
      snackbarMessage: message
    })
  }

  roleIconDisplay = (invite, register, decline) => {
    if (!invite && register && !decline) {
      return <CheckCircle style={{fill: '#29B87A'}} data-tip={`
      <div
        class='pb2 custom-tooltip'>
        ${checkJapanese()
        ? '参加します'
        : 'He or she will join'}
      </div>`}/>
    } else if (!invite && !register && decline) {
      return <Cancel style={{fill: '#F01631'}} data-tip={`
      <div
        class='pb2 custom-tooltip'>
        ${checkJapanese()
        ? '参加の拒否'
        : 'He or she cannot join'}
      </div>`}/>
    } else if (invite && !register && !decline) {
      return <MailIcon data-tip={`
      <div
        class='pb2 custom-tooltip'>
        ${checkJapanese()
        ? '招待メールは送信済みです。参加の可否の登録を待っています。'
        : 'Invitaion email has been already sent. We are waiting for whether he or she can join or not'}
      </div>`}/>
    } else if (!invite && !register && !decline) {
      return <InfoIcon data-tip={`
      <div
        class='pb2 custom-tooltip'>
        ${checkJapanese()
        ? '招待メールが送信されていません'
        : 'Invitaion email has not yet been sent.'}
      </div>`} style={{fill: '#e20f2f'}}/>
    }
  }

  handleRowSelection = row => {
    if (!this.state.singleIconClick) {
      if (row === 'all') {
        let arr = []
        this.props.participants.map((val, index) => {
          arr[index] = index
          return arr
        })
        this.setState({selectedRows: arr})
      } else if (row === 'none') {
        this.setState({selectedRows: []})
      } else {
        this.setState({selectedRows: row})
      }
    } else {
      this.setState({singleIconClick: false})
    }
  }

  render () {
    return (
      <div>
        <ReactTooltip place="left" multiline effect="solid" html/>
        {!this.props.guest ? (
          <div className="flex justify-between mb4 mt3">
            <div className="w-40">
              <InviteText
                data-tip={`
                <div
                  class='pb2 custom-tooltip'>
                  ${checkJapanese()
                  ? '参加者の名前とEmailアドレスを入力してください。\nアドレス帳をインポートすることにより作業を\n簡略化することができます。'
                  : 'Add the name and email for pariticpants. If the participants receive the invitation msg after sending it, they register if they can join or not.'}
                </div>`}
              >
                <FormattedMessage id="seminarActions.invite"/>
              </InviteText>
              <AddText>
                <FormattedMessage id="seminarActions.inviteSubheading"/>
              </AddText>
            </div>
            <div className="flex justify-end w-60">
              <FlatButton
                backgroundColor="#ecedef"
                onTouchTap={e => this.hadleListClick(e, 'preview')}
                label={<FormattedMessage id="seminarActions.previewEmail"/>}
                labelStyle={{color: '#4688F1', fontSize: 12}}
              />
              <FlatButton
                backgroundColor="#ecedef"
                onTouchTap={e => this.hadleListClick(e, 'invite')}
                style={{marginLeft: '1rem'}}
                label={<FormattedMessage id="seminarActions.addParticipant"/>}
                labelStyle={{color: '#4688F1', fontSize: 12}}
              />
              <FlatButton
                backgroundColor="#ecedef"
                onTouchTap={e => this.hadleListClick(e, 'import')}
                style={{marginLeft: '1rem'}}
                label={<FormattedMessage id="seminarActions.import"/>}
                labelStyle={{color: '#4688F1', fontSize: 12}}
              />
            </div>
          </div>
        ) : (
          ''
        )}
        <Table
          selectable={!this.props.guest}
          selectedColor="black"
          style={{tableLayout: 'auto'}}
          fixedHeader={
            !(this.state.selectedRows.length === 0 && !this.props.guest)
          }
          height={
            this.props.participants.length === 0 ||
            this.props.isFetchingParticipantList
              ? ''
              : '50vh'
          }
          onRowSelection={this.handleRowSelection}
          multiSelectable={
            this.props.participants.length !== 0 && !this.props.guest
          }
        >
          <TableHeader
            adjustForCheckbox={!this.props.guest}
            displaySelectAll={!this.props.guest}
            style={
              this.state.selectedRows.length === 0
                ? {width: '100%', backgroundColor: '#ecedef'}
                : {width: '100%', backgroundColor: '#FFFFFF'}
            }
          >
            {this.state.selectedRows.length === 0 ? (
              <TableRow
                data-tip={
                  this.props.guest
                    ? `<div
                      class='pb2 custom-tooltip'>
                      ${checkJapanese()
                    ? 'セミナーの参加者リスト'
                    : 'The list of the participants joining in this seminar'}
                    </div>`
                    : ''
                }
              >
                >
                <TableHeaderColumn style={{fontSize: 14, color: '#6B7C93'}}>
                  <FormattedMessage id="seminarActions.tableHeading.guests"/>
                </TableHeaderColumn>
                {!this.props.guest ? (
                  <TableHeaderColumn style={{fontSize: 14, color: '#6B7C93'}}>
                    <FormattedMessage id="seminarActions.tableHeading.email"/>
                  </TableHeaderColumn>
                ) : (
                  ''
                )}
                <TableHeaderColumn style={{fontSize: 14, color: '#6B7C93'}}>
                  <FormattedMessage id="seminarActions.tableHeading.user"/>
                </TableHeaderColumn>
                {!this.props.guest ? (
                  <TableHeaderColumn>
                    <div className="flex justify-end">
                      <IconMenu
                        iconButtonElement={
                          <IconButton
                            tooltip="More"
                            iconStyle={{fill: '#6B7C93'}}
                          >
                            <MoreVertIcon/>
                          </IconButton>
                        }
                        anchorOrigin={{horizontal: 'right', vertical: 'top'}}
                        targetOrigin={{horizontal: 'right', vertical: 'top'}}
                      >
                        <ListItem
                          primaryText={
                            <FormattedMessage id="seminarActions.tableOptions.add"/>
                          }
                          leftIcon={<PersonAdd/>}
                          onTouchTap={e => this.hadleListClick(e, 'invite')}
                        />
                        <ListItem
                          primaryText={
                            <FormattedMessage id="seminarActions.tableOptions.import"/>
                          }
                          leftIcon={<Contacts/>}
                          onTouchTap={e => this.hadleListClick(e, 'import')}
                        />
                        <Divider/>
                        <ListItem
                          primaryText={
                            <FormattedMessage id="seminarActions.tableOptions.sendAll"/>
                          }
                          leftIcon={<Send/>}
                          onTouchTap={e => this.hadleListClick(e, 'inviteAll')}
                        />
                        <ListItem
                          primaryText={
                            <FormattedMessage id="seminarActions.tableOptions.removeAll"/>
                          }
                          leftIcon={<Delete/>}
                          onTouchTap={e => this.hadleListClick(e, 'removeAll')}
                        />
                      </IconMenu>
                    </div>
                  </TableHeaderColumn>
                ) : (
                  ''
                )}
              </TableRow>
            ) : (
              <TableRow selectable={false}>
                <TableHeaderColumn style={{fontSize: 14, color: '#6B7C93'}}>
                  {this.state.selectedRows.length}
                  <FormattedMessage id="seminarActions.selected"/>
                </TableHeaderColumn>
                <TableHeaderColumn>
                  <div className="flex items-center justify-end">
                    <FlatButton
                      style={{paddingLeft: '1rem', paddingRight: '1rem'}}
                      onTouchTap={e =>
                        this.handleSendToMultiple(
                          e,
                          <div>
                            <FormattedMessage id="seminarActions.sentEmailMessage"/>
                            {this.state.selectedRows.length}
                            <FormattedMessage id="seminarActions.participants"/>
                          </div>
                        )}
                      touchRippleColor="green"
                    >
                      <div className="flex items-center justify-between">
                        <Send style={{fill: '#29B87A'}}/>
                        <div className="pl3" style={{color: '#29B87A'}}>
                          <FormattedMessage id="seminarActions.send"/>
                        </div>
                      </div>
                    </FlatButton>
                    <FlatButton
                      style={{paddingLeft: '1rem', paddingRight: '1rem'}}
                      onTouchTap={e =>
                        this.handleDeleteTouch(
                          e,
                          <div>
                            {this.state.selectedRows.length}
                            <FormattedMessage id="seminarActions.multipleRemovedMessage"/>
                          </div>
                        )}
                      touchRippleColor="red"
                    >
                      <div className="flex items-center justify-between">
                        <Delete style={{fill: '#F01631'}}/>
                        <div className="pl3" style={{color: '#F01631'}}>
                          <FormattedMessage id="seminarActions.remove"/>
                        </div>
                      </div>
                    </FlatButton>
                  </div>
                </TableHeaderColumn>
              </TableRow>
            )}
          </TableHeader>
          {this.props.participants.length !== 0 &&
          !this.props.isFetchingParticipantList ? (
            <TableBody
              deselectOnClickaway={false}
              displayRowCheckbox={!this.props.guest}
            >
              {this.props.participants.map((val, index) => (
                <TableRow
                  key={index}
                  selected={this.state.selectedRows.indexOf(index) !== -1}
                  style={{backgroundColor: '#f2f3f6'}}
                >
                  <TableRowColumn style={{fontSize: 14, color: '#6B7C93'}}>
                    {val.name}
                  </TableRowColumn>
                  {!this.props.guest ? (
                    <TableRowColumn style={{fontSize: 14, color: '#6B7C93'}}>
                      {val.email}
                    </TableRowColumn>
                  ) : (
                    ''
                  )}
                  <TableRowColumn style={{fontSize: 14, color: '#6B7C93'}}>
                    <ReactTooltip place="left" multiline effect="solid" html/>
                    <div className="flex items-center h-100">
                      {this.roleIconDisplay(
                        val.invite,
                        val.register,
                        val.decline
                      )}
                      <div className="pl2 ttc">
                        {val.role === 'teacher' ? (
                          <FormattedMessage id="inviteModal.teacher"/>
                        ) : val.role === 'facilitator' ? (
                          <FormattedMessage id="inviteModal.facilitator"/>
                        ) : (
                          <FormattedMessage id="inviteModal.student"/>
                        )}
                      </div>
                    </div>
                  </TableRowColumn>
                  {!this.props.guest ? (
                    <TableRowColumn
                      style={{
                        fontSize: 14,
                        color: '#6B7C93',
                        overflow: 'visible'
                      }}
                    >
                      {this.state.selectedRows.indexOf(index) === -1 ? (
                        <div className="flex justify-end">
                          <IconButton
                            onTouchTap={e =>
                              this.handleSendTouch(
                                e,
                                <div>
                                  <FormattedMessage id="seminarActions.sentEmailMessage"/>
                                  {val.name}
                                </div>,
                                'send',
                                val.id
                              )}
                            iconStyle={{fill: '#afb8c5'}}
                            touchRippleColor="green"
                            tooltip={
                              <FormattedMessage id="seminarActions.tooltipInvite"/>
                            }
                          >
                            <Send/>
                          </IconButton>
                          <IconButton
                            onTouchTap={e =>
                              this.handleSendTouch(
                                e,
                                <div>
                                  {val.name}
                                  <FormattedMessage id="seminarActions.singleRemoved"/>
                                </div>,
                                'delete',
                                val.id
                              )}
                            iconStyle={{fill: '#afb8c5'}}
                            touchRippleColor="red"
                            tooltip={
                              <FormattedMessage id="seminarActions.tooltipRemove"/>
                            }
                          >
                            <Delete/>
                          </IconButton>
                        </div>
                      ) : (
                        ''
                      )}
                    </TableRowColumn>
                  ) : (
                    ''
                  )}
                </TableRow>
              ))}
            </TableBody>
          ) : (
            <TableBody/>
          )}
        </Table>
        {this.props.participants.length === 0 ||
        this.props.isFetchingParticipantList ? (
          <div
            style={{backgroundColor: '#f2f3f6', height: '40vh'}}
            className="flex justify-center items-center"
          >
            {this.props.isFetchingParticipantList ? (
              <div className="tc">Fetching participants...</div>
            ) : (
              <div
                style={{width: '544px'}}
                className="flex flex-column justify-center items-center"
              >
                <div
                  className="tc mb4"
                  style={{fontSize: 16, color: '#6B7C93'}}
                >
                  <FormattedMessage id="seminarActions.noParticipants"/>
                </div>
                <div className="mb4">
                  <img
                    style={{height: 80, width: 80}}
                    src={images.inviteUserBigIcon}
                    alt="user"
                  />
                </div>
              </div>
            )}
          </div>
        ) : (
          ''
        )}
        <Dialog modal contentStyle={{width: '25vw'}} open={this.state.open}>
          <div className="flex justify-between items-center">
            <ALertHeaderText>
              <FormattedMessage id="seminarActions.removeModal.heading"/>
              {this.state.user}?
            </ALertHeaderText>
            <div>
              <IconButton
                onTouchTap={this.handleClose}
                iconStyle={{fill: '#afb8c5'}}
              >
                <Clear/>
              </IconButton>
            </div>
          </div>
          <AlertText className="mt3 mb3">
            <FormattedMessage id="seminarActions.removeModal.body"/>
            {this.state.user}
            <FormattedMessage id="seminarActions.removeModal.seminar"/>
          </AlertText>
          <div className="flex justify-end">
            <div className="w4">
              <FlatButton
                label={<FormattedMessage id="loggedInNavigation.cancel"/>}
                fullWidth
                onTouchTap={this.handleClose}
              />
            </div>
            <div className="ml2 w4">
              <FlatButton
                label={<FormattedMessage id="seminarActions.tooltipRemove"/>}
                fullWidth
                backgroundColor="#F01631"
                labelStyle={{color: '#FFFFFF'}}
                onTouchTap={this.handleTouchTap}
              />
            </div>
          </div>
        </Dialog>
        {false && <Snackbar
          style={{left: 200, bottom: 30}}
          open={this.state.snackbarOpen}
          message={this.state.snackbarMessage}
          action={<FormattedMessage id="seminarActions.dismiss"/>}
          onActionTouchTap={this.handleRequestClose}
          autoHideDuration={4000}
          onRequestClose={this.handleRequestClose}
        />}
        <Modal
          totalParticipants={this.props.participants.length}
          selectConferenceId={this.props.selectConferenceId}
          isFetchingList={this.props.isFetchingList}
          contacts={this.props.contacts}
          addParticipant={this.props.addParticipant}
          importParticipants={this.props.importParticipants}
          purpose={this.state.listModalPurpose}
          open={this.state.listModalOpen}
          handleClose={this.handleListModalClose}
          snackbarOpen={this.getSnackbarDetails}
          actionForAll={this.actionForAll}
          removeAll={this.removeAll}
          conferenceDetails={this.props.conferenceDetails}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Seminars/SeminarActions/Invite.js